import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import LoadingView from './Reports/Report/LoadingView/LoadingView';
import Landing from './Landing/Landing';
import Reports from './Reports/Reports';
import { getSubscribers, resetState } from './ExperianActions';
import { hasSubscribersSelector, isFetchingSubscribersSelector } from './ExperianSelector';
import ExperianContext from './ExperianContext';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

const Experian = ({ clientId, subscriberId }) => {
  const isFetchingSubscribers = useSelector(isFetchingSubscribersSelector);
  const hasSubscribers = useSelector(hasSubscribersSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSubscribers(clientId, subscriberId));

    return () => dispatch(resetState());
  }, [clientId, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  useDocumentTitle('Credit and Identity Monitoring');

  if (isFetchingSubscribers) {
    return <LoadingView />;
  }

  return (
    <ExperianContext.Provider value={{ clientId, subscriberId }}>
      {hasSubscribers ? <Reports /> : <Landing />}
    </ExperianContext.Provider>
  );
};

Experian.propTypes = {
  clientId: PropTypes.string.isRequired,
  subscriberId: PropTypes.string.isRequired,
};

export default Experian;
